import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import ApiService from 'utils/ApiCalls';
import { IFilterOptions } from 'store/ducks/Reporting/types';

const normalizeAndSort = (arr?: string[]) =>
  (arr || [])
    .filter((item): item is string => item != null)
    .sort((a, b) => a.localeCompare(b));

export const useFilterOptions = () => {
  const [filterOptions, setFilterOptions] = useState<IFilterOptions>({
    industry: [],
    group_id: [],
    module: [],
    region_id: [],
    division_id: [],
    legal_entity_id: [],
    business_unit_id: []
  });

  const { lang } = useSelector((state: RootState) => ({
    lang: state.global.lang
  }));

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const loadFilterOptions = async () => {
      setLoading(true);
      try {
        const response = await ApiService.getFilters(lang);
        const data = response.data;

        setFilterOptions({
          industry: normalizeAndSort(data.industry),
          group_id: normalizeAndSort(data.group_id),
          module: normalizeAndSort(data.module),
          region_id: normalizeAndSort(data.region_id),
          division_id: normalizeAndSort(data.division),
          legal_entity_id: normalizeAndSort(data.legal_entity),
          business_unit_id: normalizeAndSort(data.business_unit)
        });
      } catch (err) {
        setError(err);
        console.error('Failed to load filter options:', err);
      } finally {
        setLoading(false);
      }
    };

    loadFilterOptions();
  }, [lang]);

  return { filterOptions, loading, error };
};
